import { AnimatePresence, motion } from "framer-motion";
// import { wrap } from "popmotion";
import React from "react";
import { useCallback, useEffect, useState } from "react";

import Popup from "reactjs-popup";
import { Videos } from "../../AnchorContext";
import { ColorSection } from "../../ColorContext";
import { useWindowSize } from "../../utils";

import { Video } from "../Article/Video";
import { Card } from "../Card2/Card";
import { ScrollCard } from "../Slider/SliderCard";
import { Scroller } from "./Scroller";
import style from "./VideoSection.module.scss";

export const wrap = (min: number, max: number, v: number) => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

interface IVideo {
  link: string;
  description: string;
  title: string;
}

type ArrowProps = {
  onClick: VoidFunction;
};

function LeftArrow({ onClick }: ArrowProps) {
  return (
    <Arrow
      disabled={false}
      onClick={onClick}
      styleObject={{
        left: 0,
        background: "transparent",
        // "linear-gradient(90deg, rgba(233,238,241,1) 0%, rgba(2,0,36,0) 100%)",
      }}
    >
      <svg
        width="57"
        height="17"
        viewBox="0 0 57 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.29456 6.07226L54.2406 6.08288C55.4172 6.08288 56.3711 7.03542 56.3711 8.22889C56.3711 9.4141 55.4163 10.3749 54.2406 10.3749L7.28765 10.3643L9.69756 12.7881C10.5231 13.6185 10.5227 14.9651 9.68364 15.809C8.85039 16.6471 7.4945 16.6422 6.68008 15.823L0.617291 9.72521C0.206788 9.31234 0.000505816 8.7718 9.78867e-08 8.22889L0.0063699 8.21251C0.00752589 7.6675 0.212341 7.12557 0.617291 6.71828L6.68008 0.620451C7.50565 -0.20989 8.84458 -0.209469 9.68364 0.634445C10.5169 1.47252 10.512 2.83624 9.69756 3.65537L7.29456 6.07226Z"
          fill="#D32D32"
        />
      </svg>
    </Arrow>
  );
}

function RightArrow({ onClick }: ArrowProps) {
  return (
    <Arrow
      disabled={false}
      onClick={onClick}
      styleObject={{
        right: 0,
        background: "transparent",
        // "linear-gradient(90deg, rgba(2,0,36,0) 0%, rgba(233,238,241,1) 100%)",
      }}
    >
      <svg
        width="57"
        height="17"
        viewBox="0 0 57 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.0765 10.3652L2.13049 10.3546C0.953849 10.3546 -4.10978e-07 9.40208 -3.5881e-07 8.20861C-3.07002e-07 7.0234 0.954799 6.06259 2.13049 6.06259L49.0834 6.07322L46.6735 3.64938C45.848 2.81904 45.8484 1.47236 46.6875 0.62845C47.5207 -0.20962 48.8766 -0.204671 49.691 0.614458L55.7538 6.71229C56.1643 7.12516 56.3706 7.6657 56.3711 8.20861L56.3647 8.22499C56.3636 8.77 56.1588 9.31193 55.7538 9.71922L49.691 15.817C48.8654 16.6474 47.5265 16.647 46.6874 15.8031C45.8542 14.965 45.8591 13.6013 46.6735 12.7821L49.0765 10.3652Z"
          fill="#D32D32"
        />
      </svg>
    </Arrow>
  );
}

const Arrow = ({
  children,
  disabled,
  onClick,
  styleObject,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
  styleObject?: React.CSSProperties;
}) => {
  return (
    <button
      className={style.arrow}
      disabled={disabled}
      onClick={onClick}
      style={{
        padding: "20px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // position: "absolute",
        opacity: disabled ? "0" : "1",
        userSelect: "none",
        background: 'transparent',
        // height: "100%",
        // top: '50%',
        zIndex: 2,
        // ...styleObject,
      }}
    >
      {children}
    </button>
  );
};

const getVideos = (): Promise<IVideo[]> => {
  return new Promise((resolve) => {
    fetch(`/articles/videos`, {
      headers: {
        accept: "application/json",
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => resolve(data as IVideo[]));
  });
};

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
};

const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};

export const VideosSection = () => {
  const [videos, setVideos] = useState<IVideo[]>([]);
  const fetchCards = useCallback(async () => {
    const videos = await getVideos();
    setVideos(videos);
  }, []);
  useEffect(() => {
    fetchCards();
  }, [fetchCards]);

  const { width } = useWindowSize();
  let visibleCards = 3;
  if (width < 1650) {
    visibleCards = 2;
  }
  if(width < 1140){
    visibleCards = 1;
  }
  return (
    <Videos.Section>
      <ColorSection background="#e9eef1" id="Videos">
        <div className={style.videos}>
          <div className={`${style.videos__wrapper} wrapper`}>
            <div className={style["title-wrapper"]}>
              <div className={style.videos__title}>
                <div className={style.title__text}>видео</div>
              </div>
            </div>
            <Scroller
              visibleCards={visibleCards}
              ArrowLeft={width > 770 ? LeftArrow : undefined}
              ArrowRight={width > 770 ? RightArrow : undefined}
            >
              {videos.map((video, i) => {
                const cardprops = {
                  content: <VideoPreview youtube={video.link} />,
                  title: video.title,
                  description: video.description,
                };
                return <Card {...cardprops} />;
              })}
            </Scroller>
          </div>
        </div>
      </ColorSection>
    </Videos.Section>
  );
};

const VideoPreview = ({ youtube }: { youtube: string }) => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        className={style["video-preview"]}
        style={{
          backgroundImage: `url(https://i.ytimg.com/vi_webp/${
            youtube.split("/").reverse()[0]
          }/mqdefault.webp)`,
        }}
      ></button>
      <Popup modal open={open} lockScroll>
        <div className={style["popup-balckout"]}>
          <div className={style["video-popup"]}>
            <Cross onClick={closeModal} />
            <Video youtube={youtube} />
          </div>
        </div>
      </Popup>
    </>
  );
};
//<Video youtube={video.link} />

const Cross = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={style.cross} onClick={onClick}>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.21875 1.21875L19.7812 19.7812"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.21875 19.7812L19.7812 1.21875"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};
